// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"33d699a3","561":"1b113343"}[chunkId] + ".chunk.js";
};